import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { DataTypeProvider } from "@devexpress/dx-react-grid";
import { Select as MUISelect, MenuItem, InputBase } from "@material-ui/core";

import propTypes from "../../../../../constants/propTypes";

import { LoaderContext } from "../../../Loader";

export const OPERATORS = [
  { value: "=", label: "=" },
  { value: "!=", label: "≠" },
  { value: ">", label: ">" },
  { value: ">=", label: "≥" },
  { value: "<", label: "<" },
  { value: "<=", label: "≤" },
];

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
`;

const OpSelect = styled(MUISelect)`
  flex: 0 0 50px;
  width: 50px;
  font-size: 14px;
  &:before,
  &:after {
    border-bottom: none;
  }
  .MuiSelect-select {
    padding: 2px 20px 2px 4px;
    color: rgba(0, 0, 0, 0.54);
  }
`;

export const NumInput = styled(InputBase)`
  flex: 1 1 0;
  min-width: 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
  input {
    padding: 2px 0;
    width: 100%;
  }
`;

export const parseValue = value => {
  if (value && typeof value === "object") return value;
  return { op: "=", num: "" };
};

export const buildEmitValue = (op, num) =>
  num === "" ? { op, num: "" } : { op, num };

export const sanitizeNumeric = value => value.replace(/[^0-9.]/g, "");

export const EditorComponent = ({ onValueChange, value: rawValue }) => {
  const { loading } = useContext(LoaderContext);
  const initial = parseValue(rawValue);
  const [op, setOp] = useState(initial.op || "=");
  const [num, setNum] = useState(String(initial.num || ""));

  useEffect(() => {
    const parsed = parseValue(rawValue);
    setOp(parsed.op || "=");
    setNum(String(parsed.num || ""));
  }, [rawValue]);

  const handleOpChange = ({ target: { value } }) => {
    setOp(value);
    onValueChange(buildEmitValue(value, num));
  };

  const handleNumChange = ({ target: { value } }) => {
    const sanitized = sanitizeNumeric(value);
    setNum(sanitized);
    onValueChange(buildEmitValue(op, sanitized));
  };

  return (
    <Wrapper>
      <OpSelect
        value={op}
        onChange={handleOpChange}
        disabled={loading}
        disableUnderline
      >
        {OPERATORS.map(o => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </OpSelect>
      <NumInput
        value={num}
        onChange={handleNumChange}
        placeholder="Filter..."
        disabled={loading}
        inputProps={{ type: "text", inputMode: "decimal" }}
      />
    </Wrapper>
  );
};

EditorComponent.defaultProps = {
  value: "",
};

EditorComponent.propTypes = {
  onValueChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

const NumericComparisonTypeProvider = ({ columnOptions, displayFilters }) => {
  const columns = Object.keys(columnOptions).filter(
    column => columnOptions[column].filter === "numericComparison"
  );
  return displayFilters ? (
    <DataTypeProvider for={columns} editorComponent={EditorComponent} />
  ) : null;
};

NumericComparisonTypeProvider.propTypes = propTypes.filteringComponent;

export default NumericComparisonTypeProvider;
